import React from 'react';

const SearchTutorInput = ({
  className = '',
  placeholder = 'Search Tutors',
  tutorSearchQuery,
  setTutorSearchQuery,
}) => {
  return (
    <label
      className={`${className} flex items-center justify-between rounded-2xl border border-gray-300 bg-white px-4 py-3`}
    >
      <img src="images/icons/MagnifyingGlass.svg" alt="MagnifyingGlass" />
      <input
        type="text"
        className="fredoka ml-3 w-full border-none bg-inherit font-medium leading-normal -tracking-[0.16px] text-[#678285] outline-none"
        onChange={(e) => setTutorSearchQuery(e.target.value)}
        value={tutorSearchQuery}
        placeholder={placeholder}
      />
    </label>
  );
};

export default SearchTutorInput;
